<template>
  <div class="del-wrap">
    <el-dialog title="删除提醒"
               :visible="delDialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="500px"
               center>
      <p class="content">确认要删除经纪人{{agentName}}吗？</p>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancleDialog">取 消</el-button>
        <el-button type="primary"
                   @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    delDialogVisible: {
      type: Boolean,
      default: false
    },
    agentName: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancleDialog () {
      this.$emit('cancleDialog', 'delDialogVisible')
    },
    submitDialog () {
      this.$emit('submitDelDialog')
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  text-align: center;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.del-wrap /deep/ button.el-button.el-button--default {
  width: 85px;
  height: 32px;
}
</style>